import { Pipe, PipeTransform } from '@angular/core';
import {Store} from '@ngxs/store';
import {ClassroomState, ClassroomStateModel} from '@app/state/classroom-state.service';
import {GameModeModel, GameModeState} from '@app/state/game-mode.state';
import {RemoteParticipantInfo} from '@app/models/remote-participant-info';

@Pipe({
  name: 'canEnterPrivateTalk',
  pure: false
})
export class CanEnterPrivateTalkPipe implements PipeTransform {
  public constructor(private store: Store) {}

  public transform(remoteUser: RemoteParticipantInfo): boolean {
    const classroom: ClassroomStateModel = this.store.selectSnapshot(ClassroomState);
    const gameMode: GameModeModel = this.store.selectSnapshot(GameModeState);

    if (!classroom.privateTalkInfo.isStarted || !gameMode.isTeamTalkOn) {
      return true;
    }

    /* no one in private talk */
    if (Object.keys(classroom.privateTalkInfo.participants).length === 0) {
      return true;
    }

    const firstParticipantId: number = parseInt(Object.keys(classroom.privateTalkInfo.participants)[0]);

    return gameMode.participantsTeamIndexById[remoteUser.id] === gameMode.participantsTeamIndexById[firstParticipantId];
  }

}
